<template>
	<div class="topic_sum">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right"><Breadcrumb /></div>
									<h3 class="header-title mb-3">征文评审区级管理</h3>
								</div>
								<!-- end page-title-box -->
							</div>
							<!-- end col-->
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										<div class="card-nav">
											<div class="nav-tit" :class="tabIndex == 0 ? 'active' : ''" @click="checkTab(0)" >区级审核</div>
											<div v-if="shows" class="nav-tit" :class="tabIndex == 1 ? 'active' : ''"  @click="checkTab(1)">设置专家评审</div>
											<div v-if="shows"  class="nav-tit" :class="tabIndex == 2 ? 'active' : ''" @click="checkTab(2)">申报统计</div>
										</div>
										<el-form ref="queryFormRef" :model="queryForm" label-width="0px" style="width: 100%;margin-top: 20px;" v-if="tabIndex == 0">
											<el-row :gutter="10">
												<el-col :span="3">
													<el-form-item><el-input placeholder="名称" v-model="queryForm.name"></el-input></el-form-item>
												</el-col>

												<el-col :span="3">
													<el-form-item><el-input placeholder="单位名称" v-model="queryForm.affiliatedUnit"></el-input></el-form-item>
												</el-col>

												<el-col :span="3">
													<el-form-item><el-input placeholder="作者" v-model="queryForm.author"></el-input></el-form-item>
												</el-col>

												<el-col :span="3">
													<el-form-item>
														<el-select v-model="queryForm.state" clearable placeholder="审核状态">
															<el-option v-for="item in disciplineOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
														</el-select>
													</el-form-item>
												</el-col>

												<el-col :span="3">
													<el-form-item>
														<el-select v-model="queryForm.schoolSecty" clearable placeholder="学段">
															<el-option v-for="item in learingTypeOptions" :key="item.value" :label="item.label" :value="item.value"></el-option>
														</el-select>
													</el-form-item>
												</el-col>
												<el-col :span="3">
													<el-form-item>
														<el-select v-model="queryForm.discipline" clearable placeholder="学科">
															<el-option v-for="item in disciplineOptions1" :key="item.id" :label="item.name" :value="item.id"></el-option>
														</el-select>
													</el-form-item>
												</el-col>

												<el-col :span="6">
													<el-form-item><el-button type="primary" @click="getDistrictLevel">查询</el-button></el-form-item>
												</el-col>
											</el-row>
										</el-form>

										<div class="table1" v-show="tabIndex == 0">
											<el-table
												id="table"
												:header-cell-style="tableStyle"
												border
												:data="topicSumData"
												@selection-change="topicSumSelectionChange"
												:cell-class-name="cellcb"
												style="width: 100%;margin-bottom: 20px;"
											>
												<el-table-column type="selection" width="55"></el-table-column>
												<!-- <el-table-column type="index" label="序号" width="55"></el-table-column> -->
												<el-table-column prop="title" label="成果名称" width="300">
													<template slot-scope="scope">
														<div style="color: #409eff;cursor: pointer;" @click="goDetail(scope.row)">{{ scope.row.title }}</div>
													</template>
												</el-table-column>
												<el-table-column prop="author" label="作者">
													<template slot-scope="scope">
														{{ scope.row.author }},{{ scope.row.record }}
													</template>
												</el-table-column>
												<el-table-column prop="unit" label="单位"></el-table-column>
												<el-table-column prop="groupInfoName" label="评审组" width="100"></el-table-column>
												<el-table-column prop="projectTypeId" label="类别" width="60"></el-table-column>
												<el-table-column prop="createTime" label="上传时间" width="100"></el-table-column>
												<el-table-column prop="state" label="审核状态" width="90">
													<template slot-scope="scope">
														{{ scope.row.autoState | filterState }}
													</template>
												</el-table-column>
												<el-table-column prop="average" label="平均分" width="70"></el-table-column>
												<el-table-column label="操作" width="80">
													<template v-slot:default="scope">
														<el-button size="mini" v-if="scope.row.state !== 4 && scope.row.state !== 3" type="primary" @click="rowCheck(scope.row)">
															审核
														</el-button>
													</template>
												</el-table-column>
											</el-table>
											<div>
												<el-button size="mini" type="primary" @click="passStatus(4)">通过</el-button>
												<el-button size="mini" type="primary" @click="passStatus(3)">不通过</el-button>
												<el-button size="mini" type="primary" @click="exportExcel">导出Excel</el-button>
												<el-button size="mini" type="primary" @click="exportReportFile">导出附件</el-button>
											</div>
											<div class="pagination">
												<el-pagination
													@size-change="handleSizeChange"
													@current-change="handleCurrentChange"
													:current-page="queryForm.pageNumber"
													:page-sizes="[50, 100, 200]"
													:page-size="queryForm.pageSize"
													layout="total, sizes, prev, pager, next, jumper"
													:total="underStudyTopicTotal"
												></el-pagination>
											</div>
										</div>
										<div class="table1" v-show="tabIndex == 1">
											<el-table :header-cell-style="tableStyle" border :data="topicSumData2" style="width: 100%;margin-bottom: 20px;margin-top: 20px;">
												<el-table-column prop="projectName" label="评审信息名称" width="300"></el-table-column>
												<el-table-column prop="state" label="状态">
													<template v-slot:default="scope">
														{{ scope.row.flow | stateType }}
													</template>
												</el-table-column>
												<el-table-column prop="submittedNum4" label="待评数量"></el-table-column>
												<el-table-column prop="groupNum" label="评审组"></el-table-column>
												<el-table-column prop="peopleNumber" label="评审专家数"></el-table-column>
												<el-table-column prop="reviewWay" label="评审方式">
													<template v-slot:default="scope">
														{{ scope.row.reviewWay == 0 ? '匿名' : '非匿名' }}
													</template>
												</el-table-column>
												<el-table-column label="操作" width="250">
													<template v-slot:default="scope">
														<el-button size="mini" type="primary" @click="goRoute(`/backstage/reviewManage?id=${ids}&name=${scope.row.projectName}`)">
															进入管理
														</el-button>
														<el-button size="mini" type="text" @click="editRowBtn(scope.row)" v-if="scope.row.flow > 4 && scope.row.flow < 8">
															退回到评审准备
														</el-button>
														<!-- <el-button size="mini" type="text" @click="delRowBtn(scope.row)">删除</el-button> -->
													</template>
												</el-table-column>
											</el-table>
											<!-- <div>
												<el-button size="mini" type="primary" @click="dialogVisible = true" :disabled="topicSumData2.length > 0 ? true : false">
													新建评审
												</el-button>
											</div> -->
										</div>
										<div class="table1" v-show="tabIndex == 2">
											<el-table
												id="table3"
												:header-cell-style="tableStyle"
												border
												:data="topicSumData3"
												style="width: 100%;margin-bottom: 20px;margin-top: 20px;"
												show-summary
												:summary-method="getSummaries"
											>
												<el-table-column prop="unit" label="学校名称" width="500"></el-table-column>
												<el-table-column prop="num1" label="申报数量" sortable></el-table-column>
												<el-table-column prop="num2" label="学校未审核" sortable></el-table-column>
												<el-table-column prop="num3" label="学校审核通过" sortable></el-table-column>
												<el-table-column prop="num4" label="区级审核通过数" sortable></el-table-column>
											</el-table>
											<div><el-button size="mini" type="primary" @click="exportExcel2">导出Excel</el-button></div>
										</div>
									</div>
								</div>
								<!-- end card -->
							</div>
							<!-- end col-->
						</div>
					</div>
				</div>
			</div>
			<!-- end wrapper-->
			<!-- 新建评审 -->
			<el-dialog title="提示" :visible.sync="dialogVisible" width="40%" :before-close="handleClose">
				<el-form :model="ruleForm" :rules="rules" ref="addTopicFormRef" label-width="100px" class="demo-ruleForm">
					<el-form-item label="评审名称" prop="name"><el-input v-model="ruleForm.name"></el-input></el-form-item>
					<el-form-item label="评审方式" prop="reviewWay">
						<el-radio v-model="ruleForm.reviewWay" label="0">匿名评审</el-radio>
						<el-radio v-model="ruleForm.reviewWay" label="2">非匿名评审</el-radio>
					</el-form-item>
					<el-form-item label="评语" prop="comment"><el-input v-model="ruleForm.comment"></el-input></el-form-item>
					<el-form-item label="评审截止日期" prop="reviewEndTime">
						<el-date-picker
							type="datetime"
							value-format="yyyy-MM-dd HH:mm:ss"
							class="date-time"
							v-model="ruleForm.reviewEndTime"
							placeholder="选择日期"
						></el-date-picker>
					</el-form-item>
				</el-form>

				<span slot="footer" class="dialog-footer">
					<el-button @click="resetForm('ruleForm')">取 消</el-button>
					<el-button type="primary" @click="submitReview('ruleForm')">确 定</el-button>
				</span>
			</el-dialog>
		</div>
	</div>
</template>

<script>
import {
	getPageListReview,
	getReviewInfo,
	saveBasicInfo,
	delProjectById,
	batchUpdate,
	updateReview,
	apiEduReviewStick,
	saveOrUpdate,
	exportReivewReport
} from '@/api/after/newInterface.js';
import { getReportFile } from '@/api/after/topicManage.js';
import { getPlatformInformationData } from '@/api/after/systemManagement.js';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue';
import XLSX from 'xlsx';
import FileSaver from 'file-saver';
export default {
	components: {
		Breadcrumb
	},
	data() {
		return {
			dialogVisible: false,
			tabIndex: 0, //tab
			queryForm: {
				pageNumber: 1,
				pageSize: 10,
				name: null,
				state: null,
				schoolSecty: null
			},
			disciplineOptions: [
				// {
				// 	value: 0,
				// 	label: '待审核'
				// },
				// {
				// 	value: 1,
				// 	label: '未通过'
				// },
				{
					value: 2,
					label: '初审通过'
				},
				{
					value: 3,
					label: '终审通过'
				},
				{
					value: 4,
					label: '终审未通过'
				}
			],
			disciplineOptions1: [],
			tableStyle: {
				backgroundColor: '#7e9be2',
				color: '#fff',
				textAlign: 'center'
			},
			learingTypeOptions: [
				{
					value: 0,
					label: '幼儿园'
				},
				{
					value: 1,
					label: '小学'
				},
				{
					value: 2,
					label: '初中'
				},
				{
					value: 3,
					label: '高中'
				},
				{
					value: 4,
					label: '高/中职'
				},
				{
					value: 5,
					label: '其他'
				}
			],
			topicSumData: [],
			topicSumData2: [],
			topicSumData3: [],
			topicSumSelectionList: [],
			underStudyTopicTotal: 10,
			ruleForm: {
				name: '',
				reviewWay: '',
				comment: '',
				reviewEndTime: ''
			},
			rules: {
				name: [{ required: true, message: '请输入评审名称', trigger: 'blur' }],
				reviewWay: [{ required: true, message: '请选择评审方式', trigger: 'blur' }],
				comment: [{ required: true, message: '请选择评语', trigger: 'blur' }],
				reviewEndTime: [{ required: true, message: '请选择截止日期', trigger: 'blur' }]
			},
			ids: '',
			userInfo:"",
			createId:"",
			shows:"",
		};
	},
	filters: {
		stateType(val) {
			if (val < 4 || val == 4) {
				return '评审准备';
			} else if (val > 4 && val < 8) {
				return '专家评审中';
			} else {
				return '已结束';
			}
		},
		filterState(val) {
			if (val == 0) {
				return '待审核';
			}
			if (val == 1) {
				return '初审未通过';
			}
			if (val == 2) {
				return '初审通过';
			}
			if (val == 4) {
				return '终审通过';
			}
			if (val == 3) {
				return '终审未通过';
			}
		}
	},
	created() {
		this.getDiscipline();
		this.getDistrictLevel();
		this.ids = this.$route.query.id;
		this.createId=this.$route.query.createId
		this.userInfo=JSON.parse(sessionStorage.getItem("userInfo"))
		this.shows=this.createId==this.userInfo.id||this.userInfo.roleId.indexOf("9")!=-1
		console.log(this.createId==this.userInfo.id);
	},
	methods: {
		// 导出报告附件
		async exportReportFile() {
			let ids = this.topicSumData.map(item => item.id).join(',');
			const res = await exportReivewReport(ids);
			//创建一个a标签并实现下载功能
			const link = document.createElement('a');
			let blob = new Blob([res], { type: 'application/octet-stream' }); //res是文件流
			link.style.display = 'none';
			link.href = URL.createObjectURL(blob);
			link.download = '区级审核.zip'; //下载的文件名
			document.body.appendChild(link);
			link.click();
			document.body.removeChild(link);
		},
		//table复选
		cellcb(row) {
			if (row.row.state == 4 || row.row.state == 3) {
				return 'myCell';
			}
		},
		editRowBtn(row) {
			this.$confirm('退回后专家无法进行评分，确定要将本次评审退回到“评审准备”阶段吗？', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			}).then(() => {
				saveOrUpdate({ id: row.id, flow: 1 }).then(res => {
					if (res.code == 200) {
						this.$message.success(res.msg);
						this.getSpecialist();
					} else {
						this.$message.error(res.msg);
					}
				});
			});
		},
		getSummaries(param) {
			const { columns, data } = param;
			const sums = [];
			columns.forEach((column, index) => {
				if (index === 0) {
					sums[index] = '合计';
					return;
				}
				const values = data.map(item => Number(item[column.property]));
				if (!values.every(value => isNaN(value))) {
					sums[index] = values.reduce((prev, curr) => {
						const value = Number(curr);
						if (!isNaN(value)) {
							return prev + curr;
						} else {
							return prev;
						}
					}, 0);
				} else {
					sums[index] = 'N/A';
				}
			});

			return sums;
		},
		goDetail(row) {
			this.$router.push(`/backstage/schoolDetail?id=${row.id}&projectId=${this.ids}&showTitle=${1}`);
		},
		rowCheck(row) {
			this.$router.push(`/backstage/schoolDetail?id=${row.id}&projectId=${this.ids}&auditType=${3}`);
		},
		exportExcel2() {
			let exportFileName = '申报统计.xlsx';
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(document.querySelector('#table3'), xlsxParam);
			var wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), exportFileName);
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		// 导出excel
		exportExcel() {
			let exportFileName = '区级审核.xlsx';
			var xlsxParam = { raw: true };
			var wb = XLSX.utils.table_to_book(document.querySelector('#table'), xlsxParam);
			var wbout = XLSX.write(wb, {
				bookType: 'xlsx',
				bookSST: true,
				type: 'array'
			});
			try {
				FileSaver.saveAs(new Blob([wbout], { type: 'application/octet-stream' }), exportFileName);
			} catch (e) {
				if (typeof console !== 'undefined') {
					console.log(e, wbout);
				}
			}
			return wbout;
		},
		passStatus(type) {
			if (this.topicSumSelectionList.length > 0) {
				this.topicSumSelectionList = this.topicSumSelectionList.map(item => item.id);
				let params = {
					ids: this.topicSumSelectionList,
					state: type
				};
				batchUpdate(params).then(res => {
					if (res.code == 200) {
						this.$message.success(res.msg);
						this.getDistrictLevel();
					} else {
						this.$message.error(res.data);
					}
				});
			} else {
				this.$message.warning('请勾选数据');
			}
		},
		delRowBtn(row) {
			this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning'
			})
				.then(() => {
					if (res.code == 200) {
						delProjectById(row.groupId).then(res => {
							this.$message.success(res.msg);
							this.getSpecialist();
						});
					} else {
						this.$message.error(res.msg);
					}
				})
				.catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
		},
		checkTab(type) {
			this.tabIndex = type;
			if (type == 0) {
				this.getDistrictLevel();
			}
			if (type == 1) {
				this.getSpecialist();
			}
			if (type == 2) {
				this.getT();
			}
		},
		getT() {
			apiEduReviewStick(1, this.$route.query.id).then(res => {
				if (res.code == 200) {
					this.topicSumData3 = res.data;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		handleSizeChange(val) {
			this.queryForm.pageSize = val;
			this.getDistrictLevel();
		},
		handleCurrentChange(val) {
			this.queryForm.pageNumber = val;
			this.getDistrictLevel();
		},
		// 区级审核
		getDistrictLevel() {
			let params = {
				pageNumber: this.queryForm.pageNumber,
				pageSize: this.queryForm.pageSize,
				projectId: this.$route.query.id,
				title: this.queryForm.name,
				unit: this.queryForm.affiliatedUnit,
				author: this.queryForm.author,
				state: this.queryForm.state,
				disciplineId: this.queryForm.disciplineId,
				learningSection: this.queryForm.schoolSecty,
				quji: true
				// xiaozu:1
			};
			getPageListReview(params).then(res => {
				if (res.code == 200) {
					this.topicSumData = res.data.records;
					
					this.underStudyTopicTotal = res.data.total;
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		//专家评审
		getSpecialist() {
			getReviewInfo(this.$route.query.id).then(res => {
				if (res.code == 200) {
					this.topicSumData2 = [];
					this.topicSumData2.push(res.data);
					let reviewWay = '';
					if (this.topicSumData2.length > 0) {
						this.topicSumData2.forEach(item => {
							if (item.eduExpertsSubjectGroup) {
								reviewWay = item.eduExpertsSubjectGroup.reviewWay ? item.eduExpertsSubjectGroup.reviewWay : '';
							}
							this.$set(item, 'reviewWay', reviewWay);
						});
					}
				} else {
					this.$message.error(res.msg);
				}
			});
		},
		goRoute(url) {
			this.$router.push(url);
		},
		topicSumSelectionChange(val) {
			this.topicSumSelectionList = val;
		},

		handleClose(done) {
			this.$confirm('确认关闭？')
				.then(_ => {
					done();
				})
				.catch(_ => {});
		},
		//新增评审
		submitReview(formName) {
			this.$refs.addTopicFormRef.validate(async valid => {
				if (valid) {
					this.ruleForm.projectId = this.$route.query.id;
					saveBasicInfo(this.ruleForm).then(res => {
						if (res.code !== 200) {
							this.$message.error(res.msg);
						} else {
							this.$message.success(res.msg);
						}
						this.resetForm();
					});
				}
			});
		},
		//重置表单
		resetForm() {
			this.dialogVisible = false;
			for (let key in this.ruleForm) {
				this.ruleForm[key] = '';
			}
			this.$refs.addTopicFormRef.resetFields();
		},
		// 获取学科
		async getDiscipline() {
			const res = await getPlatformInformationData(8);
			if (res.code == 200) {
				this.disciplineOptions1 = res.data;
			} else {
				this.$message.error(res.data);
			}
		}
	}
};
</script>

<style scoped lang="scss">
::v-deep .el-date-editor.el-input {
	width: 100%;
}
.btn_wrap {
	margin-bottom: 20px;
	display: flex;
	align-items: center;
}
.pagination {
	display: flex;
	justify-content: center;
}
::v-deep .el-form-item__label {
	min-width: max-content !important;
}
.card {
	.card-body {
		.card-nav {
			border-bottom: 4px solid #c3c3c3;
			font-weight: 600;
			display: flex;
			align-items: flex-end; /*  */
			font-size: 17px;
			.nav-tit {
				width: 150px;
				text-align: center;
				cursor: default;
			}
		}
		.active {
			color: #00a2e8 !important ;
			font-size: 22px;
		}
		.active::after {
			content: '';
			width: 150px;
			height: 4px;
			background-color: #00a2e8;
			display: block;
			position: absolute;
			margin-top: 0.5px;
		}
	}
}
.date-time {
	width: 99% !important;
	position: absolute;
}
::v-deep .myCell .el-checkbox__input {
	display: none;
}
</style>
